function services() {
	const $mainServices = $('main.services');
	if (!$mainServices.length) return;

	const $accordionHeaders = $('.accordion-header');

	$accordionHeaders.on('click', function() {
		const $header = $(this);
		const isExpanded = $header.attr('aria-expanded') === 'true';
		const $content = $('#' + $header.attr('aria-controls'));

		$accordionHeaders.not($header).each(function() {
			const $otherHeader = $(this);
			if ($otherHeader.attr('aria-expanded') === 'true') {
				$otherHeader.attr('aria-expanded', 'false');
				$('#' + $otherHeader.attr('aria-controls')).slideUp(300);
			}
		});

		$header.attr('aria-expanded', !isExpanded);
		$content.slideToggle(300);
	});
}
